import {
    useState,
    type Dispatch,
    type MouseEvent,
    type SetStateAction,
} from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import EditRoundedIcon from '@mui/icons-material/EditRounded'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'

import { useDeletePayLessInstruction } from '@/hooks/api/use-pay-less-instruction'
import type { PayLessInstruction } from '@/types'

function HowToPayLessActions({
    payLessInstruction,
    setEdit,
}: {
    payLessInstruction: PayLessInstruction,
    setEdit: Dispatch<SetStateAction<boolean>>
}) {

    const [deleteConfirmation, setDeleteConfirmation] = useState<boolean>(false)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
        setDeleteConfirmation(false)
    }

    const mutation = useDeletePayLessInstruction(payLessInstruction.id)

    const handleDelete = () => {
        mutation.mutate()
    }

    return (
        <>
            <Tooltip title="Více možností">
                <IconButton
                    id="actions-button"
                    aria-label="actions"
                    aria-controls={open ? 'actions-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    color="terciary"
                    onClick={handleClick}
                    sx={{ backgroundColor: 'editableOrange.main' }}
                >
                    <MoreVertRoundedIcon />
                </IconButton>
            </Tooltip>
            <Menu
                id="actions-menu"
                MenuListProps={{
                    'aria-labelledby': 'actions-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: '15ch',
                        }
                    }
                }}
            >
                <MenuItem onClick={() => {
                    setEdit(true)
                    handleClose()
                }}>
                    <ListItemIcon>
                        <EditRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Upravit obsah
                </MenuItem>
                {deleteConfirmation ?
                    <MenuItem
                        onClick={() => {
                            handleDelete()
                            handleClose()
                        }}
                        sx={{
                            color: 'error.main',
                        }}
                    >
                        <ListItemIcon>
                            <DeleteRoundedIcon fontSize="small" color="error" />
                        </ListItemIcon>
                        Potvrdit
                    </MenuItem>
                    :
                    <MenuItem onClick={() => setDeleteConfirmation(true)}>
                        <ListItemIcon>
                            <DeleteRoundedIcon fontSize="small" />
                        </ListItemIcon>
                        Smazat
                    </MenuItem>
                }
            </Menu>
        </>
    )
}

export default HowToPayLessActions
